export const PackageModulesInfoLinks = {
  Module: {
    FullDiskEncryption: {
      Partners: 'https://www.bitdefender.com/business/support/en/77211-376312-full-disk-encryption.html',
      Cloud: 'https://www.bitdefender.com/business/support/en/77209-376312-full-disk-encryption.html',
      OnPremise: 'https://www.bitdefender.com/business/support/en/77212-376312-full-disk-encryption.html',
    },
  },
  Roles: {
    Relay: {
      Partners:
        'https://www.bitdefender.com/business/support/en/77211-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm126759362833878',
      Cloud:
        'https://www.bitdefender.com/business/support/en/77209-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm126759362833878',
      OnPremise:
        'https://www.bitdefender.com/business/support/en/77212-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm126759362833878',
    },
    PatchManagementCacheServer: {
      Partners:
        'https://www.bitdefender.com/business/support/en/77211-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm128449203542347',
      Cloud:
        'https://www.bitdefender.com/business/support/en/77209-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm128449203542347',
      OnPremise:
        'https://www.bitdefender.com/business/support/en/77212-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm128449203542347',
    },
    ExchangeProtection: {
      Partners:
        'https://www.bitdefender.com/business/support/en/77211-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm1210139044250816',
      Cloud:
        'https://www.bitdefender.com/business/support/en/77209-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm1210139044250816',
      OnPremise:
        'https://www.bitdefender.com/business/support/en/77212-392421-understanding-gravityzone-architecture.html#UUID-941caf91-83ab-df88-874d-48da797457d2_section-idm1210139044250816',
    },
  },
};
